import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchVenues: [],
  myVanues: [],
  adminVanues: [],
  usersList: [],
};

const reducers = {
  getAdminVanues: (state: any, action: any) => {
    const newItems = action.payload.items;

    state.adminVanues = newItems;
  },
  adminBlockVenue: (state: any, action: any) => {
    const temp = [...state.adminVanues];
    const venueId = action.payload.id;

    const index = temp.findIndex((item) => item.id === venueId);

    console.log("Updated Vanue :", index, temp);

    state.adminVanues[index] = {
      ...temp[index],
      status: temp[index].status === "blocked" ? "published" : "blocked",
    };
  },
  getAdminUsersList: (state: any, action: any) => {
    const newItems = action.payload.items;

    state.usersList = newItems;
  },
  updateUserListItem: (state: any, action: any) => {
    const temp = [...state.usersList];
    const newItemId = action.payload.id;

    const index = temp.findIndex((item) => item.id === newItemId);

    console.log("TEMP :", index, temp);

    state.usersList[index] = {
      ...temp[index],
      blocked: !temp[index].blocked,
    };
  },

  getVanues: (state: any, action: any) => {
    const newItems = action.payload.items;

    state.searchVenues = newItems;

    // state.searchVenues = [];
  },
  getMyVanues: (state: any, action: any) => {
    const newItems = action.payload.items;

    state.myVanues = newItems;
  },
  createVanue: (state: any, action: any) => {
    const newItem = action.payload.item;
    const items = [newItem, ...state.myVanues];

    state.myVanues = items;
  },
  updateVanue: (state: any, action: any) => {
    const temp = [...state.myVanues];

    const newItem = action.payload.item;

    const index = temp.findIndex((item) => item.id === newItem.id);

    state.myVanues[index] = newItem;
  },
  deleteVanue: (state: any, action: any) => {
    const tempItems = [...state.myVanues];
    const itemId = action.payload.id;

    const updatedList = tempItems.filter((item) => item.id !== itemId);

    state.myVanues = updatedList;
  },
  // Silently adjust a venue's space count in the lists when a space is added or
  // deleted, so the spaces panel doesn't have to reload the whole venue list.
  // `delta` is +1 (added) or -1 (removed). The list shows item.spaces.length /
  // spaces_count / spacesCount, so keep all of them consistent.
  adjustVenueSpaceCount: (state: any, action: any) => {
    const { venueId, delta } = action.payload;

    const applyToList = (list: any[]) => {
      const index = list.findIndex((item) => item.id === venueId);
      if (index === -1) return;

      const venue = list[index];
      const currentSpaces = Array.isArray(venue.spaces) ? venue.spaces : [];

      let spaces = currentSpaces;
      if (delta > 0) {
        // Add a lightweight placeholder so length reflects the new count.
        spaces = [...currentSpaces, { id: `pending-${Date.now()}` }];
      } else if (delta < 0 && currentSpaces.length > 0) {
        spaces = currentSpaces.slice(0, -1);
      }

      const baseCount =
        venue.spaces_count ?? venue.spacesCount ?? currentSpaces.length;
      const nextCount = Math.max(0, baseCount + delta);

      list[index] = {
        ...venue,
        spaces,
        ...(venue.spaces_count !== undefined ? { spaces_count: nextCount } : {}),
        ...(venue.spacesCount !== undefined ? { spacesCount: nextCount } : {}),
      };
    };

    applyToList(state.adminVanues);
    applyToList(state.myVanues);
  },
};

const vanueSlice = createSlice({
  name: "venues",
  initialState,
  reducers,
});

export const {
  getAdminVanues,
  adminBlockVenue,
  getVanues,
  getMyVanues,
  createVanue,
  updateVanue,
  deleteVanue,
  adjustVenueSpaceCount,
  getAdminUsersList,
  updateUserListItem,
} = vanueSlice.actions;

export default vanueSlice.reducer;
